module.exports = __webpack_public_path__ + "img/five_dining_philo.ddc91ca9.png";